import { PartnerVoucherStatus } from "../../services/api";

export const VOUCHER_STATUS_OPTIONS: Array<{ value: string; label: string }> = [
  { value: "all", label: "Tất cả" },
  { value: "available", label: "Có sẵn" },
  { value: "issued", label: "Đã phát hành" },
  { value: "redeemed", label: "Đã đổi" },
  { value: "revoked", label: "Đã thu hồi" },
];

export const voucherStatusLabel = (status: PartnerVoucherStatus | string) => {
  const found = VOUCHER_STATUS_OPTIONS.find((o) => o.value === status);
  return found?.label || status;
};

export const voucherStatusBadgeClass = (status: PartnerVoucherStatus | string) => {
  switch (status) {
    case "available":
      return "bg-blue-100 dark:bg-blue-900/30 text-blue-800 dark:text-blue-300";
    case "issued":
      return "bg-yellow-100 dark:bg-yellow-900/30 text-yellow-800 dark:text-yellow-300";
    case "redeemed":
      return "bg-green-100 dark:bg-green-900/30 text-green-800 dark:text-green-300";
    case "revoked":
      return "bg-red-100 dark:bg-red-900/30 text-red-800 dark:text-red-300";
    default:
      return "bg-gray-100 dark:bg-gray-700 text-gray-800 dark:text-gray-300";
  }
};

export const formatDateTime = (value?: string) => {
  if (!value) return "—";
  return new Date(value).toLocaleString("vi-VN");
};
